import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, SubmissionError } from 'redux-form';
import { TextField, SelectField, Toggle, Checkbox } from 'redux-form-material-ui';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem'

import { editPackage, putPackages } from "store/packages/actions";
import { updateUserName } from 'store/auth/actions';
import { checkRequiredFields } from "forms";
import { translate } from "react-i18next";
import { translateDifficulty } from "utils";


class PackageChangeForm extends Component {

    saveRef = ref => (this.ref = ref);

    componentDidMount() {
        this.ref // the Field
            .getRenderedComponent() // on Field, returns ReduxFormMaterialUITextField
            .getRenderedComponent() // on ReduxFormMaterialUITextField, returns TextField
            .focus() // on TextField
    }

    render() {
        let diffChoices = this.props.difficulties.map(diff => {
            return <MenuItem key={diff.id} value={diff.id} primaryText={diff.code + ' - ' + translateDifficulty(diff)} />
        });
        const termsURL = process.env.REACT_APP_WEB_BASE_URL + this.props.t('publish_package_terms_relative_url');
        return (
            <form onSubmit={this.props.handleSubmit(this.props.onSubmit)}>
                <Field maxLength={100} name="name" component={TextField} hintText={this.props.t('package_management_new_package_name')} ref={this.saveRef} withRef /><br />
                <span style={{ 'display': this.props.isPublished ? 'initial' : 'none' }}>
                    <Field name="difficulty" component={SelectField} hintText={this.props.t('publish_package_difficulty')}>
                        {diffChoices}
                    </Field><br />
                    <Field name="user_name" component={TextField} hintText={this.props.t('username_placeholder')} /><br />
                    <Field name="description" component={TextField} hintText={this.props.t('publish_package_description')} /><br />
                    <div style={{ marginTop: '20px' }}>
                        <div style={{ width: '30px', height: '40px', maxWidth: '40px', float: 'left' }}>
                            <Field required={this.props.isPublished} name="terms_agree" component={Checkbox} type="checkbox" />
                        </div>
                        <div style={{ lineHeight: '24px', color: 'black', marginLeft: '45px' }}>
                            {this.props.t('publish_package_terms_1')} <a href={termsURL} style={{ color: 'black' }} target="_blank">{this.props.t('publish_package_terms_2')}</a>
                        </div>
                    </div>
                </span>
                <Field name="published" component={Toggle} labelPosition={"right"} style={{ marginTop: '20px' }} label={this.props.t('package_management_publish_package')} /> <br />
                {this.props.error && <strong style={{ color: 'red' }}>{this.props.error}</strong>}
                <div style={{ textAlign: 'right', padding: 8, margin: '24px -24px -24px -24px' }}>
                    {this.props.actions}
                </div>
                {/*<RaisedButton label="Login" primary={true} type="submit" disabled={this.props.submitting}/>*/}
            </form>
        )
    }
}

PackageChangeForm = reduxForm({
    form: 'packageChangeForm',
})(translate()(PackageChangeForm));
const selector = formValueSelector('packageChangeForm'); // <-- same as form name


PackageChangeForm = connect(
    state => {
        const isPublished = selector(state, 'published') || false;
        return {
            isPublished,
        }
    }
)(PackageChangeForm);


const customContentStyle = {
    marginTop: '-170px'
};

class PackageChangeDialog extends Component {
    sendForm = (values) => {
        let requiredFields = ['name',];
        if (values.published === true) {
            if (this.props.cards.length < 5) {
                throw new SubmissionError({ '_error': this.props.t('publish_package_not_enough_cards', { 1: '5' }) })
            }
            requiredFields = [...requiredFields, 'difficulty']

        }
        checkRequiredFields(requiredFields, values);
        return (dispatch, getState) => {
            dispatch(editPackage(this.props.package, values));
            dispatch(putPackages());
            if (values.published === true) {
                dispatch(updateUserName(values.user_name))
            }
            this.props.onCancelClick()
        }
    };

    submitForm = (values, dispatch) => {
        return dispatch(this.sendForm(values));
    };

    render() {
        const initialValues = this.props.initialValues ? this.props.initialValues : {};
        const actions = [
            <FlatButton
                label={this.props.t('dialog_dismiss')}
                // primary={true}
                onClick={this.props.onCancelClick}
                key="cancel"
            />,
            <FlatButton
                type="submit"
                label={this.props.t('dialog_save')}
                primary={true}
                keyboardFocused={true}
                key="submit"
            // onClick={this.handleClose}
            />,
        ];
        return (
            <Dialog autoScrollBodyContent={true} contentStyle={customContentStyle} open={this.props.open} title={this.props.t('package_management_edit_package')}>
                <PackageChangeForm difficulties={this.props.difficulties} initialValues={{ ...this.props.package, ...initialValues, user_name: this.props.userName }} actions={actions} onSubmit={this.submitForm} />
            </Dialog>

        )
    }
}

const mapStateToProps = (state) => {
    return { difficulties: state.difficulty.difficulties }
};

export default connect(mapStateToProps)(translate()(PackageChangeDialog));




// WEBPACK FOOTER //
// ./src/components/packages/PackageChangeDialog.js